import {ApiClientInterface} from "./clients";
import {CompanySuggestion} from "./models/company";

export class CompanyManager {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public async get(query: string): Promise<Array<CompanySuggestion>> {
    return this.apiClient.get("/suggestions", {query});
  }
}